<template>
  <div class="listPage">
    <b-row class="mt-2 mb-5 justify-content-start">
      <!-- Left section filtre -->
      <b-col cols="4" lg="2" xl="2">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>

    </b-row>
    <b-row class="justify-content-start" v-if="displayFilter">
      <!--Filtre Name -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
        <label class="filter-item-title" for="annuaire-name">{{ $t('annuaire.file_name') }}</label>
        <span class="filter-item-content">
          <input v-model="Name" id="annuaire-name"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
            :placeholder="$t('annuaire.file_name')"
            style="width: 100%">
        </span>
      </b-col>

      <!-- Filtre date de début -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
          :inputLabel="$t('common.date_start_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBegin">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
          :inputLabel="$t('common.date_end_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEnd">
        </datetime-picker-custom>
      </b-col>

      <!-- Bouton Effacer et Appliquer -->
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-4 pb-5">
        <b-button size="sm"
          @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
          @click="clearFilterFields"
          :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
<!--    <div class="d-flex justify-content-end" v-if="AnnuairesList.length > 0">-->
<!--      <b-button class="btnFilter_2 mx-3"-->
<!--        @click="extractCSV()">-->
<!--        <i class="fa-light fa-upload fs-14px"></i>-->
<!--        <span class="fab-label">{{ $t('common.extract_list') }}</span>-->
<!--      </b-button>-->
<!--    </div>-->
    <b-row class="ustify-content-start">
      <!--Filtre Name -->
      <b-col sm="12" lg="12" cols="12" class="w-100">
        <spinner v-if="activateSpinner"></spinner>
        <b-table responsive hover v-else-if="AnnuairesList.length > 0"
                 class="table table-striped"
                 :fields="fields"
                 :items="AnnuairesList"
                 :selectable="AnnuairesList.length > 0"
                 :empty-text="$t('common.security.no_result')"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDir"
                 @head-clicked="sortTable"
                 @row-selected="seeAnnuairesDetails">
          <template #cell(FileName)="data">
            <span>{{ data.value }}</span>
          </template>
          <template #cell(DateImport)="data">
            <span>{{ getDate(data.value) }}</span>
          </template>
          <template #cell(Status)="data">
            <span>{{ $t('annuaire.status_import_'+data.value)}}</span>
          </template>
        </b-table>
        <div v-else class="d-flex justify-content-center">
          <span class="noResult">
            {{ $t('common.no_result') }}
          </span>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col>
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download";


export default {
  name: 'AnnuaireFilePage',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      fields = [
        { key: 'FileName', label: this.$i18n.t('annuaire.file_name'), class: 'text-center', sortable: true },
        { key: 'DateImport', label: this.$i18n.t('annuaire.date_import'), class: 'text-center', sortable: true },
        { key: 'LineCount', label: this.$i18n.t('annuaire.line_count'), class: 'text-center', sortable: true },
        { key: 'Status', label: this.$i18n.t('annuaire.status_import'), class: 'text-center', sortable: true },
        // { key: 'File', label: this.$i18n.t('annuaire.file'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      filterConditions: {},
      hasDefaultFilter: false,
      idAnnuaireAcc: '',
      statusVerification: '',
      mode: 1,
      identifier: '',
      technicalStatus: '',
      Name: '',
      IBAN: '',
      tabName: 1,
      dateBegin: '',
      dateEnd: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'DateImport',
      sortBy: '',
      sortDir: false,
      trackActive: '',
      AnnuairesList: [],
    }
  },
  created () {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    if (this.type == 'DDV'){
      this.tabName = 1
    }else{
      this.tabName = 2
    }
    // this.$bus.$emit('switch-selected-menu', '/annuairebulk/:id')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Annuaire',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.annuaire.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      this.filterConditions = filterConditions

      this.AnnuairesList = []
      let that = this
      this.filterTypeGet = 'list'
      this.$engine.annuaire.cleanFilterCondition()


      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name.trim()
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.$engine.annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
        that.paginationObject.nbResults = resp.data.annuaires.length
        requests = resp.data.annuaires
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.Name = ''
      this.dateEnd = ''
      this.dateBegin = ''
      this.communicateChange()
      // this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults :this.paginationObject.maxResults,
        firstIndex :this.paginationObject.firstIndex,
      }


      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name.trim()

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      this.$engine.annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        this.AnnuairesList = []
        let requests = {}
        if (resp.data) {
          that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
          that.paginationObject.nbResults = resp.data.annuaires.length
          requests = resp.data.annuaires
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false

      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    extractCSV () {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let filterConditions = {
        maxResults :this.paginationObject.maxResults,
        firstIndex :this.paginationObject.firstIndex,
        extract : 1,
      }


      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name.trim()

      this.$engine.annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + resp.data
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.annuaire_file') + '_' + today.unix() + '.csv'
        if (
            this.$f7.device.os === 'android' ||
            this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))

      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    changeTabName (tabName) {
      this.tabName = tabName
      this.onRefresh()
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/annuaire/file/' + id})
    },
    reOrderBy (column) {
      this.AnnuairesList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'DateImport':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions


      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name.trim()

      this.$engine.annuaire.getAnnuaires(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
        that.paginationObject.nbResults = resp.data.annuaires.length
        requests = resp.data.annuaires
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.AnnuairesList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeAnnuairesDetails (items) {
      this.activateDetail(items[0].IdAnnuaire)
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm')
      }
      else {
        return '-'
      }
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>
